class QuoteCarousel extends HTMLElement {
  constructor() {
    super();
    this.quoteCards = this.querySelectorAll('.quote-card-container');
    this.container = this.querySelector('.embla');

    this.slides = this.querySelectorAll('.embla__slide');
    this.embla = null;

    // Set first quote active immediately
    const firstQuote = this.quoteCards[0];
    if (firstQuote) {
      this.setActiveQuote(firstQuote, false);
    }

    this.init();
    this.addEventListeners();
  }

  init() {
    if (window.innerWidth < 768) {
      this.initEmbla();
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth < 768 && !this.embla) {
        this.initEmbla();
      } else if (window.innerWidth >= 768 && this.embla) {
        this.embla.destroy();
        this.embla = null;
      }
    });
  }

  initEmbla() {
    this.embla = new EmblaCarousel(this.container, {
      loop: true,
      align: 'start',
      skipSnaps: false,
    });

    this.embla.on('select', () => {
      const currentSlide = this.embla.selectedScrollSnap();
      const activeCard = this.quoteCards[currentSlide];
      if (activeCard) {
        this.setActiveQuote(activeCard, false);
      }
    });

    const progressNode = this.querySelector('.embla__progress__bar');
    const updateProgress = () => {
      const progress = Math.max(0, Math.min(1, this.embla.scrollProgress()));
      progressNode.style.transform = `scaleX(${progress})`;
    };

    this.embla.on('scroll', updateProgress);
    this.embla.on('reInit', updateProgress);

    // Set first slide active on init
    const firstQuote = this.quoteCards[0];
    if (firstQuote) {
      this.setActiveQuote(firstQuote, false);
    }
  }

  addEventListeners() {
    this.quoteCards.forEach((card, index) => {
      card.addEventListener('click', () => {
        this.setActiveQuote(card, true);
        if (this.embla) {
          this.embla.scrollTo(index);
        }
      });
      card.addEventListener('mouseenter', () => {
        this.setActiveQuote(card, true);
        if (this.embla) {
          this.embla.scrollTo(index);
        }
      });
    });
  }

  setActiveQuote(activeCard, updateCarousel = false) {
    this.quoteCards.forEach((card) => {
      card.classList.remove('active');
      const authorCard = card.closest('.quote-card-container').querySelector('.author-card');
      if (authorCard) authorCard.classList.remove('active');
    });

    activeCard.classList.add('active');
    const activeAuthorCard = activeCard.closest('.quote-card-container').querySelector('.author-card');
    if (activeAuthorCard) activeAuthorCard.classList.add('active');
  }
}

customElements.define('quote-carousel', QuoteCarousel);
